import React from "react";
import RoundedRectangle from "../RoundedRectangle";
import MatchTile from "../Match/MatchTile";
import type { LastMatchData } from "../../../config/types";

type PlayerLastMatchProps = {
  lastMatch: LastMatchData;
};

const PlayerLastMatch: React.FC<PlayerLastMatchProps> = ({ lastMatch }) => (
  <RoundedRectangle
    className="rounded-xl mb-4 bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark"
    hasBorder
    hasTitle
    titleType="upLeft"
    titleKey="lastMatch"
  >
    <div className="px-4 py-4">
      <MatchTile
        match={lastMatch.matchElement}
        banner="date-league"
        playerData={lastMatch.playerData}
      />
    </div>
  </RoundedRectangle>
);

export default PlayerLastMatch;

